import React from 'react';
import pluralize from 'pluralize';
import { Col, Row } from 'react-bootstrap';
import SidebarSection from '../../../Sidebar/SidebarSection/SidebarSection';
import getIncludedResource from '../../../../../../helpers/getIncludedResource';
import Broker from '../../../Sidebar/Broker/Broker';
import SchemeSummary from '../../../Sidebar/SchemeSummary/SchemeSummary';
import QuoteActions from '../../../Sidebar/QuoteActions/QuoteActions';
import MtaPremiumSummary from '../../../Sidebar/MtaPremiumSummary/MtaPremiumSummary';
import MtaPremiumOverride from '../../../Sidebar/MtaPremiumOverride/MtaPremiumOverride';
import flatten from 'flat';
import PremiumAdjust from '../../../Sidebar/PremiumAdjust/PremiumAdjust';
import AdminFeeAdjust from '../../../Sidebar/AdminFeeAdjust/AdminFeeAdjust';
import './Sidebar.scss';

const ValidationErrors = ({ validationErrors, submitFailed }) => {
  if (!submitFailed || !validationErrors.length) {
    return null;
  }
  return (
    <Col sm={12} className="quote-divider">
      <div className="error-box">
        <h4>Attention required</h4>
        <ul>
          {validationErrors.map((field) => (
            <li>{field}</li>
          ))}
        </ul>
      </div>
    </Col>
  );
};

const Sidebar = ({
  productName,
  showSave,
  showNext,
  showSchemeInfo,
  calculateQuotes,
  application,
  source,
  isMta,
  selectedSchemes,
  calculatedPremiums,
  isSaving,
  isCalculating,
  isPremiumAdjusting,
  handleCommissionAdjustments,
  goToNextPage,
  saveAndExit,
  saveEmailAndExit,
  isSubmitting,
  formErrors,
  submitFailed,
}) => {
  const applyAdminFeeOverride = () => {
    return calculateQuotes();
  };
  if (!application) {
    return null;
  }

  const hasEmail = !!application.data.attributes.metadata.travellers[0].email;
  const validationErrors = Object.values(flatten(formErrors));
  const selectedSchemeId = selectedSchemes?.[0]?.id;

  const selectedScheme = calculatedPremiums?.find(
    (premium) => premium.meta.scheme.id === selectedSchemeId,
  );
  const selectedPremium = selectedScheme?.meta;
  const applicationMetadata = application.data.attributes.metadata;

  return (
    <div>
      <div className="sl-sidebar">
        <div className={'sidebar-sticky-container'}>
          <Row className="sticky-inner-container sticky-sidebar">
            <Col xs={12}>
              <h4 className="quote-summary-title">
                <span>
                  {' '}
                  Quote Summary {isMta && <span className="mta-logo-sidebar">MTA</span>}
                </span>
              </h4>
            </Col>
            <SidebarSection label={'Product'} info={productName} />
            <SidebarSection
              label={'Policy number'}
              info={application.data.attributes.policy_number}
            />
            {!!applicationMetadata.num_travellers && (
              <SidebarSection
                label={'Tags:'}
                info={`${pluralize(
                  'individuals',
                  applicationMetadata.num_travellers,
                )} x ${applicationMetadata.num_travellers}`}
              />
            )}

            <ValidationErrors
              validationErrors={validationErrors}
              submitFailed={submitFailed}
            />
            <Broker
              broker={getIncludedResource(
                application.data,
                application.included,
                'broker',
              )}
              source={source}
            />
            {selectedSchemes.map((selectedScheme) => {
              const selectedPremium = calculatedPremiums?.find(
                (calculatedPremium) =>
                  calculatedPremium.meta?.scheme.id === selectedScheme.id,
              )?.meta;

              const mtaPremium = selectedPremium?.mta;
              return (
                <>
                  <SchemeSummary
                    key={selectedPremium?.scheme.id}
                    isSaving={isSaving}
                    isMta={isMta}
                    selection={selectedPremium}
                    isSmartLuggage
                  />

                  <MtaPremiumSummary
                    premium={mtaPremium ? mtaPremium.new_premium : null}
                    scheme={selectedPremium?.scheme}
                    benefits={selectedPremium?.benefits}
                    taxRate={selectedPremium?.rates.tax_rate}
                    isMta={isMta}
                  />
                  <MtaPremiumSummary
                    premium={mtaPremium ? mtaPremium.new_premium : null}
                    scheme={selectedPremium}
                    benefits={selectedPremium?.benefits}
                    taxRate={selectedPremium?.rates.tax_rate}
                    isMta={isMta}
                    payable={selectedPremium}
                  />
                </>
              );
            })}

            {!isSubmitting && selectedSchemes.length > 0 && (
              <QuoteActions
                showSave={showSave}
                showEmail={hasEmail && showSave}
                saveAndExit={saveAndExit}
                saveEmailAndExit={saveEmailAndExit}
                goToNextPage={goToNextPage}
                isSaving={isSaving}
                showNext={showNext}
              />
            )}
            {showSchemeInfo && selectedPremium && (
              <>
                <MtaPremiumOverride
                  hasPremiums={!!selectedSchemes.length}
                  selectedPremium={selectedPremium}
                  isMta={isMta}
                  handleGrossOverride={applyAdminFeeOverride}
                />
                <PremiumAdjust
                  selectedScheme={selectedPremium}
                  isMta={isMta}
                  isCalculating={isCalculating}
                  handleCommissionAdjustments={handleCommissionAdjustments}
                />
                <AdminFeeAdjust
                  selectedScheme={selectedPremium}
                  isPremiumAdjusting={isPremiumAdjusting}
                  applyAdminFeeOverride={applyAdminFeeOverride}
                />
              </>
            )}
          </Row>
        </div>
      </div>
    </div>
  );
};
export default Sidebar;
